import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import CircledExclamationmarkIcon from 'icons/CircledExclamationmark.icon';

import './NoUsersFound.styles.scss';

type NoUsersFoundProps = {
  className?: string;
};

const NoUsersFound: React.FC<NoUsersFoundProps> = (props) => {
  const { className } = props;

  const classes = classNames('no-users-found', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <CircledExclamationmarkIcon />
      {t('noUserFound')}
    </div>
  );
};

export default NoUsersFound;
